import './Invitation.scss';

const Invitation = () => {
  return (
    <section className="invitation">
      <div className="invitation__content">
        <div className="invitation__text">
          <h2 className="invitation__title">Дорогие друзья и родные!</h2>

          <p className="invitation__description">
            С огромной радостью приглашаем вас разделить с нами один из самых важных дней в нашей жизни —
            День нашей свадьбы!
          </p>


          <p className="invitation__date">21.06.2026</p>
        </div>

        <div className="invitation__photo-container">
          <img
            className="invitation__photo"
            src="/молодожены.png"
            alt="Вадим и Дарья"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default Invitation;
